// extracted by mini-css-extract-plugin
export default {"main":"main-Na90n"};